import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
      APP_NAME: 'My Accounting',
      ASSISTANT_TITLE: 'Assistant',
      ASSISTANT_BACK: 'Back',
      ASSISTANT_MESSAGE_COUNT: '{{count}} messages',
      ASSISTANT_OPEN: 'Open assistant',
      ASSISTANT_CLOSE: 'Close assistant',
      ASSISTANT_SEND: 'Send',
      ASSISTANT_PIN: 'Dock at the side',
      ASSISTANT_UNPIN: 'Undock',
      ASSISTANT_CLEAR: 'Clear conversation',
      ASSISTANT_PLACEHOLDER: 'Ask about your finances',
      ASSISTANT_EMPTY: 'Ask me something, for example: what is my balance?',
      ASSISTANT_THINKING: 'Thinking...',
      ASSISTANT_ANALYSING: 'Analysing your data...',
      ASSISTANT_TOOL_ACCOUNTS: 'Checking your accounts...',
      ASSISTANT_TOOL_CATEGORIES: 'Checking your categories...',
      ASSISTANT_TOOL_TRANSACTIONS: 'Checking your transactions...',
      ASSISTANT_TOOL_TRANSACTIONS_SUMMARY: 'Adding up your transactions...',
      ASSISTANT_TOOL_MONTH: 'Checking the month...',
      ASSISTANT_TOOL_YEAR: 'Checking the year...',
      ASSISTANT_TOOL_OTHER: 'Checking your data...',
      ASSISTANT_ERROR: 'The assistant is not available right now.',
      DASHBOARD: 'Dashboard',
      ACCOUNTS: 'Accounts',
      TRANSACTIONS: 'Transactions',
      CATEGORIES: 'Categories',
      SIGN_IN: 'Sign In',
      CANCEL: 'Cancel',
      TOTAL: 'Total',
      TOTAL_BALANCE: 'Total Balance',
      NET_RESULT: 'Net result',
      ACCOUNT_TYPE_CASH: 'Cash',
      ACCOUNT_TYPE_BANK: 'Bank',
      ACCOUNT_TYPE_SAVINGS: 'Savings',
      ACCOUNT_TYPE_INVESTMENT: 'Investment',
      CATEGORY_ICON: 'Icon',
      // Generic icons:
      CATEGORY_ICON_HIVE: 'Hive',
      CATEGORY_ICON_CAR: 'Car',
      CATEGORY_ICON_SCISSORS: 'Scissors',
      CATEGORY_ICON_HOME: 'Home',
      CATEGORY_ICON_SHAPES: 'Shapes',
      CATEGORY_ICON_GAS: 'Gas Station',
      CATEGORY_ICON_MAIL: 'Mail',
      CATEGORY_ICON_GYM: 'Gym',
      CATEGORY_ICON_PEOPLE: 'People',
      CATEGORY_ICON_LIGHTNING: 'Lightning',
      CATEGORY_ICON_SCHOOL: 'School',
      CATEGORY_ICON_PARKING: 'Parking',
      CATEGORY_ICON_CASINO: 'Casino',
      CATEGORY_ICON_BEACH: 'Beach',
      CATEGORY_ICON_LAPTOP: 'Laptop',
      CATEGORY_ICON_BABY: 'Baby',
      CATEGORY_ICON_ANDROID: 'Android',
      CATEGORY_ICON_GAVEL: 'Gavel',
      CATEGORY_ICON_COMPUTER: 'Computer',
      CATEGORY_ICON_CHART: 'Chart',
      CATEGORY_ICON_PERCENT: 'Percent',
      CATEGORY_ICON_LAUNDRY: 'Laundry',
      CATEGORY_ICON_ATM: 'ATM',
      CATEGORY_ICON_BOOK: 'Book',
      CATEGORY_ICON_SHOPPING: 'Shopping',
      CATEGORY_ICON_TWO_WHEELER: 'Motorcycle',
      CATEGORY_ICON_ENGINEER: 'Engineering',
      CATEGORY_ICON_CASH: 'Cash',
      CATEGORY_ICON_SAVINGS: 'Piggy Bank',
      CATEGORY_ICON_GIFT: 'Gift',
      CATEGORY_ICON_SOLAR: 'Solar',
      CATEGORY_ICON_PALETTE: 'Palette',
      CATEGORY_ICON_RETURN: 'Return',
      CATEGORY_ICON_BUILDING: 'Building',
      CATEGORY_ICON_RESTAURANT: 'Restaurant',
      CATEGORY_ICON_PHARMACY: 'Pharmacy',
      CATEGORY_ICON_SHIELD: 'Shield',
      CATEGORY_ICON_HEART_SHIELD: 'Heart Shield',
      CATEGORY_ICON_ROUTER: 'Router',
      CATEGORY_ICON_PHONE: 'Smartphone',
      CATEGORY_ICON_ARROWS: 'Arrows',
      CATEGORY_ICON_BUS: 'Bus',
      CATEGORY_ICON_HANGER: 'Hanger',
      CATEGORY_ICON_TOLLS: 'Tolls',
      CATEGORY_ICON_FLIGHT: 'Flight',
      CATEGORY_ICON_DROP: 'Water Drop',
      CATEGORY_ICON_PAYSLIP: 'Payslip',
      CATEGORY_ICON_FAMILY: 'Family',
      CATEGORY_ICON_OTHER: 'Other',

      // Legacy fallbacks:
      CATEGORY_ICON_FOOD: 'Food',
      CATEGORY_ICON_TRANSPORT: 'Transport',
      CATEGORY_ICON_UTILITIES: 'Utilities',
      CATEGORY_ICON_ENTERTAINMENT: 'Entertainment',
      CATEGORY_ICON_HEALTH: 'Health',
      CATEGORY_ICON_EDUCATION: 'Education',
      CATEGORY_ICON_HOUSING: 'Housing',
      CATEGORY_ICON_TRAVEL: 'Travel',
      USERNAME_PLACEHOLDER: 'Username',
      PASSWORD_PLACEHOLDER: 'Password',
      LOGGING_IN: 'Logging in...',
      LOGIN_FAILED: 'Invalid username or password',
      LOGIN_UNEXPECTED: 'An unexpected error occurred. Please try again later.',
      RESET_PASSWORD_TITLE: 'Reset Password',
      CONFIRMATION_CODE_PLACEHOLDER: 'Confirmation Code',
      NEW_PASSWORD_PLACEHOLDER: 'New Password',
      RESET_PASSWORD: 'Reset Password',
      WELCOME: 'Welcome to your dashboard',
      FINANCIAL_OVERVIEW: 'Financial Overview',
      MONTHLY_BALANCE: 'Monthly Balance',
      BALANCE_OVER_TIME: 'Balance Over Time',
      MONTHLY_CASHFLOWS: 'Monthly Cashflows',
      ACCOUNT_BREAKDOWN: 'Account Breakdown',
      EXPENSES_BY_CATEGORY: 'Expenses by Category',
      INCOME_BY_CATEGORY: 'Income by Category',
      EXPENSES_BY_CATEGORY_THIS_MONTH: 'Expenses by Category (This Month)',
      CATEGORY_DISTRIBUTION: 'Category Distribution',
      CATEGORY_TREND: 'Category Trend',
      EDIT_CATEGORY_SUCCESS_TOAST: {
        TITLE: '',
        MESSAGE: 'Category updated successfully',
      },
      EDIT_CATEGORY_ERROR_TOAST: {
        TITLE: '',
        MESSAGE: 'Failed to update category',
      },
      EDIT_CATEGORY_MODAL: {
        TITLE: 'Edit Category',
        CONFIRM: 'Save',
        CLOSE: 'Close',
      },
      ROWS_PER_PAGE: 'Rows per page:',
      OF: 'of',
      MORE_THAN: 'more than',
      SELECT_MONTH: 'Select Month',
      LOGOUT: 'Log Out',
      NO_TRANSACTIONS_FOUND_MESSAGE: 'No transactions found',
      TRANSACTIONS_SUMMARY_COUNT_one: '{{count}} transaction',
      TRANSACTIONS_SUMMARY_COUNT_other: '{{count}} transactions',
      TRANSACTIONS_SUMMARY_DEBIT: 'Expenses',
      TRANSACTIONS_SUMMARY_CREDIT: 'Income',
      TRANSACTIONS_SUMMARY_TRANSFER: 'Transfers',
      NO_ACCOUNTS_FOUND_MESSAGE: 'No accounts found',
      NO_CATEGORIES_FOUND_MESSAGE: 'No categories found',
      ERROR_BOUNDARY_TITLE: 'Oops! Something went wrong.',
      BACK_TO_HOME: 'Back to Home',
      CRITICAL_ERROR: 'Critical Error',
      CONNECTION_ERROR: 'Connection Error',
      OFFLINE_DESC:
        'No connection to the server. Please check your internet connection or try again.',
      SERVER_ERROR_DESC:
        'We are experiencing server difficulties. Please try again later.',
      RETRY: 'Retry',
      NEW_VERSION_AVAILABLE: 'A new version is available',
      RELOAD: 'Reload',
      LATER: 'Later',
      EDIT_TRANSACTION_SUCCESS_TOAST: {
        TITLE: '',
        MESSAGE: 'Transaction updated successfully',
      },
      EDIT_TRANSACTION_ERROR_TOAST: {
        TITLE: '',
        MESSAGE: 'Failed to update transaction',
      },
      THEME_DARK: 'Dark Mode',
      THEME_LIGHT: 'Light Mode',
      TOTALS: 'Totals',
      CREATE: 'Create',
      SUBMIT: 'Submit',
      REFRESH: 'Refresh',
      DISTRIBUITION: 'Distribution',
      EXPENSES: 'Expenses',
      INCOME: 'Income',
      REVENUE: 'Revenue',
      CREATE_NEW_ACCOUNT: 'Create Account',
      BALANCE: 'Balance',
      BALANCE_DISTRIBUITION_CARD_TITLE: 'Distribution',
      ACCOUNT_NAME: 'Name',
      ACCOUNT_BALANCE: 'Balance',
      ACCOUNT_TYPE: 'Type',
      TRANSACTION_TYPE: 'Type',
      TRANSACTION_AMOUNT: 'Amount',
      TRANSACTION_DATE: 'Date',
      TRANSACTION_ACCOUNTS: 'Account(s)',
      TRANSACTION_OTHER_ACCOUNT: 'Destination Account',
      TRANSACTION_ACCOUNT: 'Account',
      TRANSACTION_CATEGORY: 'Category',
      TRANSACTION_DESCRIPTION: 'Description',
      TRANSACTION_TYPE_CREDIT: 'Income',
      TRANSACTION_TYPE_DEBIT: 'Expense',
      TRANSACTION_TYPE_TRANSFER: 'Transfer',
      CLEAR_FILTERS: 'Clear filters',
      LOADING: 'Loading...',
      TRANSACTION_DATE_FROM: 'From',
      TRANSACTION_DATE_TO: 'To',
      REGISTER_NEW_TRANSACTION: 'Register Transaction',
      COPY_TRANSACTION: 'Copy Transaction',
      CREATE_NEW_CATEGORY: 'Create Category',
      CATEGORY_NAME: 'Name',
      CATEGORY_DESCRIPTION: 'Description',
      BALANCE_HISTORY_CARD_TITLE: 'History',
      CASHFLOWS_CARD_TITLE: 'Cashflows',
      CREATE_ACCOUNT_SUCCESS_TOAST: {
        TITLE: '',
        MESSAGE: 'New account created successfully',
      },
      CREATE_ACCOUNT_ERROR_TOAST: {
        TITLE: '',
        MESSAGE: 'An error occurred while creating the new account',
      },
      EDIT_ACCOUNT_SUCCESS_TOAST: {
        TITLE: '',
        MESSAGE: 'Account updated successfully',
      },
      EDIT_ACCOUNT_ERROR_TOAST: {
        TITLE: '',
        MESSAGE: 'Failed to update the account',
      },
      EDIT_ACCOUNT_MODAL: {
        TITLE: 'Edit Account',
        CONFIRM: 'Save',
        CLOSE: 'Close',
      },
      DELETE_ACCOUNT_SUCCESS_TOAST: {
        TITLE: '',
        MESSAGE: 'Account deleted successfully',
      },
      DELETE_ACCOUNT_ERROR_TOAST: {
        TITLE: '',
        MESSAGE: 'Oops! An error occurred while deleting the account',
      },
      DELETE_ACCOUNT_MODAL: {
        TITLE: 'Delete account?',
        DESCRIPTION: 'Are you sure you want to delete the account "{{name}}"?',
        TITLE_NOT_ZEROED: 'The account still has a balance.',
        DESCRIPTION_NOT_ZEROED:
          'The account "{{name}}" still has {{balance}}. It is not possible to delete it.',
        CONFIRM: 'Delete',
        CLOSE: 'Close',
      },
      CREATE_CATEGORY_SUCCESS_TOAST: {
        TITLE: '',
        MESSAGE: 'New category created successfully',
      },
      CREATE_CATEGORY_ERROR_TOAST: {
        TITLE: '',
        MESSAGE: 'An error occurred while creating the new category',
      },
      DELETE_CATEGORY_SUCCESS_TOAST: {
        TITLE: '',
        MESSAGE: 'Category deleted successfully',
      },
      DELETE_CATEGORY_ERROR_TOAST: {
        TITLE: '',
        MESSAGE: 'Oops! An error occurred while deleting the category',
      },
      DELETE_CATEGORY_MODAL: {
        TITLE: 'Delete category?',
        DESCRIPTION: 'Are you sure you want to delete the category "{{name}}"?',
        CONFIRM: 'Delete',
        CLOSE: 'Close',
      },
      CREATE_TRANSACTION_SUCCESS_TOAST: {
        TITLE: '',
        MESSAGE: 'New transaction registered successfully',
      },
      CREATE_TRANSACTION_ERROR_TOAST: {
        TITLE: '',
        MESSAGE: 'An error occurred while registering the new transaction',
      },
      DELETE_TRANSACTION_SUCCESS_TOAST: {
        TITLE: '',
        MESSAGE: 'Transaction deleted successfully',
      },
      DELETE_TRANSACTION_ERROR_TOAST: {
        TITLE: '',
        MESSAGE: 'Oops! An error occurred while deleting the transaction',
      },
      DELETE_TRANSACTION_MODAL: {
        TITLE: 'Delete transaction?',
        DESCRIPTION_DEBIT:
          'Are you sure you want to delete the expense "{{description}}" of {{amount}}?',
        DESCRIPTION_CREDIT:
          'Are you sure you want to delete the income "{{description}}" of {{amount}}?',
        DESCRIPTION_TRANSFER:
          'Are you sure you want to delete the transfer "{{description}}" of {{amount}}?',
        CONFIRM: 'Delete',
        CLOSE: 'Close',
      },
      EDIT_TRANSACTION_MODAL: {
        TITLE: 'Edit Transaction',
        CONFIRM: 'Save',
        CLOSE: 'Close',
      },
      NO_DATA: 'No data',
    },
  },
  pt: {
    translation: {
      APP_NAME: 'A minha contabilidade',
      ASSISTANT_TITLE: 'Assistente',
      ASSISTANT_BACK: 'Voltar',
      ASSISTANT_MESSAGE_COUNT: '{{count}} mensagens',
      ASSISTANT_OPEN: 'Abrir assistente',
      ASSISTANT_CLOSE: 'Fechar assistente',
      ASSISTANT_SEND: 'Enviar',
      ASSISTANT_PIN: 'Fixar ao lado',
      ASSISTANT_UNPIN: 'Soltar',
      ASSISTANT_CLEAR: 'Limpar conversa',
      ASSISTANT_PLACEHOLDER: 'Pergunte sobre as suas finanças',
      ASSISTANT_EMPTY: 'Pergunte-me algo, por exemplo: qual é o meu saldo?',
      ASSISTANT_THINKING: 'A pensar...',
      ASSISTANT_ANALYSING: 'A analisar os dados...',
      ASSISTANT_TOOL_ACCOUNTS: 'A consultar as contas...',
      ASSISTANT_TOOL_CATEGORIES: 'A consultar as categorias...',
      ASSISTANT_TOOL_TRANSACTIONS: 'A consultar os movimentos...',
      ASSISTANT_TOOL_TRANSACTIONS_SUMMARY: 'A somar os movimentos...',
      ASSISTANT_TOOL_MONTH: 'A consultar o mês...',
      ASSISTANT_TOOL_YEAR: 'A consultar o ano...',
      ASSISTANT_TOOL_OTHER: 'A consultar os dados...',
      ASSISTANT_ERROR: 'O assistente não está disponível de momento.',
      DASHBOARD: 'Painel',
      WELCOME: 'Bem-vindo ao seu painel',
      TOTAL: 'Total',
      TOTALS: 'Totais',
      CREATE: 'Criar',
      CANCEL: 'Cancelar',
      SUBMIT: 'Submeter',
      REFRESH: 'Atualizar',
      DISTRIBUITION: 'Distribuição',
      EXPENSES: 'Despesas',
      INCOME: 'Receitas',
      NET_RESULT: 'Balanço',
      REVENUE: 'Receitas',
      ACCOUNTS: 'Contas',
      CREATE_NEW_ACCOUNT: 'Criar conta',
      BALANCE: 'Saldo',
      BALANCE_DISTRIBUITION_CARD_TITLE: 'Distribuição',
      ACCOUNT_NAME: 'Nome',
      ACCOUNT_BALANCE: 'Saldo',
      ACCOUNT_TYPE: 'Tipo',
      ACCOUNT_TYPE_CASH: 'Numerário',
      ACCOUNT_TYPE_BANK: 'Bancária',
      ACCOUNT_TYPE_SAVINGS: 'Poupança',
      ACCOUNT_TYPE_INVESTMENT: 'Investimentos',
      TRANSACTIONS: 'Movimentos',
      TRANSACTION_TYPE: 'Tipo',
      TRANSACTION_AMOUNT: 'Montante',
      TRANSACTION_DATE: 'Data',
      TRANSACTION_ACCOUNTS: 'Conta(s)',
      TRANSACTION_OTHER_ACCOUNT: 'Conta de destino',
      TRANSACTION_ACCOUNT: 'Conta',
      TRANSACTION_CATEGORY: 'Categoria',
      TRANSACTION_DESCRIPTION: 'Descrição',
      TRANSACTION_TYPE_CREDIT: 'Receita',
      TRANSACTION_TYPE_DEBIT: 'Despesa',
      TRANSACTION_TYPE_TRANSFER: 'Transferência',
      CLEAR_FILTERS: 'Limpar filtros',
      LOADING: 'A carregar...',
      TRANSACTION_DATE_FROM: 'Desde',
      TRANSACTION_DATE_TO: 'Até',
      REGISTER_NEW_TRANSACTION: 'Registar movimento',
      COPY_TRANSACTION: 'Copiar movimento',
      CATEGORIES: 'Categorias',
      CREATE_NEW_CATEGORY: 'Criar categoria',
      CATEGORY_NAME: 'Nome',
      CATEGORY_DESCRIPTION: 'Descrição',
      CATEGORY_ICON: 'Ícone',
      // Generic icons:
      CATEGORY_ICON_HIVE: 'Colmeia',
      CATEGORY_ICON_CAR: 'Carro',
      CATEGORY_ICON_SCISSORS: 'Tesoura',
      CATEGORY_ICON_HOME: 'Casa',
      CATEGORY_ICON_SHAPES: 'Formas',
      CATEGORY_ICON_GAS: 'Posto de Combustível',
      CATEGORY_ICON_MAIL: 'Correio',
      CATEGORY_ICON_GYM: 'Ginásio',
      CATEGORY_ICON_PEOPLE: 'Pessoas',
      CATEGORY_ICON_LIGHTNING: 'Raio',
      CATEGORY_ICON_SCHOOL: 'Escola',
      CATEGORY_ICON_PARKING: 'Estacionamento',
      CATEGORY_ICON_CASINO: 'Casino',
      CATEGORY_ICON_BEACH: 'Praia',
      CATEGORY_ICON_LAPTOP: 'Portátil',
      CATEGORY_ICON_BABY: 'Bebé',
      CATEGORY_ICON_ANDROID: 'Android',
      CATEGORY_ICON_GAVEL: 'Martelo',
      CATEGORY_ICON_COMPUTER: 'Computador',
      CATEGORY_ICON_CHART: 'Gráfico',
      CATEGORY_ICON_PERCENT: 'Percentagem',
      CATEGORY_ICON_LAUNDRY: 'Lavandaria',
      CATEGORY_ICON_ATM: 'Multibanco',
      CATEGORY_ICON_BOOK: 'Livro',
      CATEGORY_ICON_SHOPPING: 'Compras',
      CATEGORY_ICON_TWO_WHEELER: 'Mota',
      CATEGORY_ICON_ENGINEER: 'Engenharia',
      CATEGORY_ICON_CASH: 'Dinheiro',
      CATEGORY_ICON_SAVINGS: 'Mealheiro',
      CATEGORY_ICON_GIFT: 'Presente',
      CATEGORY_ICON_SOLAR: 'Solar',
      CATEGORY_ICON_PALETTE: 'Paleta',
      CATEGORY_ICON_RETURN: 'Retorno',
      CATEGORY_ICON_BUILDING: 'Edifício',
      CATEGORY_ICON_RESTAURANT: 'Restaurante',
      CATEGORY_ICON_PHARMACY: 'Farmácia',
      CATEGORY_ICON_SHIELD: 'Escudo',
      CATEGORY_ICON_HEART_SHIELD: 'Escudo com Coração',
      CATEGORY_ICON_ROUTER: 'Router',
      CATEGORY_ICON_PHONE: 'Telemóvel',
      CATEGORY_ICON_ARROWS: 'Setas',
      CATEGORY_ICON_BUS: 'Autocarro',
      CATEGORY_ICON_HANGER: 'Cabide',
      CATEGORY_ICON_TOLLS: 'Portagens',
      CATEGORY_ICON_FLIGHT: 'Voo',
      CATEGORY_ICON_DROP: 'Gota de Água',
      CATEGORY_ICON_PAYSLIP: 'Recibo',
      CATEGORY_ICON_FAMILY: 'Família',
      CATEGORY_ICON_OTHER: 'Outro',

      // Legacy fallbacks:
      CATEGORY_ICON_FOOD: 'Alimentação',
      CATEGORY_ICON_TRANSPORT: 'Transporte',
      CATEGORY_ICON_UTILITIES: 'Serviços',
      CATEGORY_ICON_ENTERTAINMENT: 'Lazer',
      CATEGORY_ICON_HEALTH: 'Saúde',
      CATEGORY_ICON_EDUCATION: 'Educação',
      CATEGORY_ICON_HOUSING: 'Habitação',
      CATEGORY_ICON_TRAVEL: 'Viagens',
      TOTAL_BALANCE: 'Saldo total',
      BALANCE_HISTORY_CARD_TITLE: 'Histórico',
      CASHFLOWS_CARD_TITLE: 'Balanços',
      FINANCIAL_OVERVIEW: 'Visão Geral Financeira',
      MONTHLY_BALANCE: 'Saldo Mensal',
      BALANCE_OVER_TIME: 'Saldo ao Longo do Tempo',
      MONTHLY_CASHFLOWS: 'Fluxos de Caixa Mensais',
      ACCOUNT_BREAKDOWN: 'Distribuição por Conta',
      EXPENSES_BY_CATEGORY: 'Despesas por Categoria',
      INCOME_BY_CATEGORY: 'Receitas por Categoria',
      EXPENSES_BY_CATEGORY_THIS_MONTH: 'Despesas por Categoria (Este Mês)',
      CATEGORY_DISTRIBUTION: 'Distribuição por Categoria',
      CATEGORY_TREND: 'Tendência da Categoria',
      CREATE_ACCOUNT_SUCCESS_TOAST: {
        TITLE: '',
        MESSAGE: 'Nova conta criada com sucesso',
      },
      CREATE_ACCOUNT_ERROR_TOAST: {
        TITLE: '',
        MESSAGE: 'Ocorreu um erro ao criar a nova conta',
      },
      EDIT_ACCOUNT_SUCCESS_TOAST: {
        TITLE: '',
        MESSAGE: 'Conta atualizada com sucesso',
      },
      EDIT_ACCOUNT_ERROR_TOAST: {
        TITLE: '',
        MESSAGE: 'Ups! Ocorreu um erro ao atualizar a conta',
      },
      EDIT_ACCOUNT_MODAL: {
        TITLE: 'Editar conta',
        CONFIRM: 'Submeter',
        CLOSE: 'Fechar',
      },
      DELETE_ACCOUNT_SUCCESS_TOAST: {
        TITLE: '',
        MESSAGE: 'Conta apagada com sucesso',
      },
      DELETE_ACCOUNT_ERROR_TOAST: {
        TITLE: '',
        MESSAGE: 'Ups! Ocorreu um erro ao apagar a conta',
      },
      DELETE_ACCOUNT_MODAL: {
        TITLE: 'Apagar conta?',
        DESCRIPTION: 'Tem a certeza que deseja apagar a conta "{{name}}"?',
        TITLE_NOT_ZEROED: 'A conta ainda tem saldo.',
        DESCRIPTION_NOT_ZEROED:
          'A conta "{{name}}" ainda tem {{balance}}. Não é possível apagá-la.',
        CONFIRM: 'Apagar',
        CLOSE: 'Fechar',
      },
      CREATE_CATEGORY_SUCCESS_TOAST: {
        TITLE: '',
        MESSAGE: 'Nova categoria criada com sucesso',
      },
      CREATE_CATEGORY_ERROR_TOAST: {
        TITLE: '',
        MESSAGE: 'Ocorreu um erro ao criar a nova categoria',
      },
      DELETE_CATEGORY_SUCCESS_TOAST: {
        TITLE: '',
        MESSAGE: 'Categoria apagada com sucesso',
      },
      DELETE_CATEGORY_ERROR_TOAST: {
        TITLE: '',
        MESSAGE: 'Ups! Ocorreu um erro ao categoria a conta',
      },
      DELETE_CATEGORY_MODAL: {
        TITLE: 'Apagar categoria?',
        DESCRIPTION: 'Tem a certeza que deseja apagar a categoria "{{name}}"?',
        CONFIRM: 'Apagar',
        CLOSE: 'Fechar',
      },
      EDIT_CATEGORY_SUCCESS_TOAST: {
        TITLE: '',
        MESSAGE: 'Categoria atualizada com sucesso',
      },
      EDIT_CATEGORY_ERROR_TOAST: {
        TITLE: '',
        MESSAGE: 'Ups! Ocorreu um erro ao atualizar a categoria',
      },
      EDIT_CATEGORY_MODAL: {
        TITLE: 'Editar categoria',
        CONFIRM: 'Submeter',
        CLOSE: 'Fechar',
      },
      CREATE_TRANSACTION_SUCCESS_TOAST: {
        TITLE: '',
        MESSAGE: 'Novo movimento registado com sucesso',
      },
      CREATE_TRANSACTION_ERROR_TOAST: {
        TITLE: '',
        MESSAGE: 'Ocorreu um erro ao registar o novo movimento',
      },
      DELETE_TRANSACTION_SUCCESS_TOAST: {
        TITLE: '',
        MESSAGE: 'Movimento apagado com sucesso',
      },
      DELETE_TRANSACTION_ERROR_TOAST: {
        TITLE: '',
        MESSAGE: 'Ups! Ocorreu um erro ao apagar o movimento',
      },
      DELETE_TRANSACTION_MODAL: {
        TITLE: 'Apagar movimento?',
        DESCRIPTION_DEBIT:
          'Tem a certeza que deseja apagar a despesa "{{description}}" no valor de {{amount}}?',
        DESCRIPTION_CREDIT:
          'Tem a certeza que deseja apagar a receita "{{description}}" no valor de {{amount}}?',
        DESCRIPTION_TRANSFER:
          'Tem a certeza que deseja apagar a transferência "{{description}}" no valor de {{amount}}?',
        CONFIRM: 'Apagar',
        CLOSE: 'Fechar',
      },
      EDIT_TRANSACTION_MODAL: {
        TITLE: 'Editar movimento',
        CONFIRM: 'Submeter',
        CLOSE: 'Fechar',
      },
      NO_DATA: 'Sem dados',
      SIGN_IN: 'Entrar',
      USERNAME_PLACEHOLDER: 'Utilizador',
      PASSWORD_PLACEHOLDER: 'Palavra-passe',
      LOGGING_IN: 'A entrar...',
      LOGIN_FAILED: 'Utilizador ou palavra-passe incorretos',
      LOGIN_UNEXPECTED:
        'Ocorreu um erro inesperado. Por favor, tente mais tarde.',
      RESET_PASSWORD_TITLE: 'Redefinir palavra-passe',
      CONFIRMATION_CODE_PLACEHOLDER: 'Código de confirmação',
      NEW_PASSWORD_PLACEHOLDER: 'Nova palavra-passe',
      RESET_PASSWORD: 'Redefinir palavra-passe',
      ROWS_PER_PAGE: 'Linhas por página:',
      OF: 'de',
      MORE_THAN: 'mais de',
      SELECT_MONTH: 'Selecionar mês',
      LOGOUT: 'Sair',
      NO_TRANSACTIONS_FOUND_MESSAGE: 'Nenhum movimento encontrado',
      TRANSACTIONS_SUMMARY_COUNT_one: '{{count}} movimento',
      TRANSACTIONS_SUMMARY_COUNT_other: '{{count}} movimentos',
      TRANSACTIONS_SUMMARY_DEBIT: 'Despesas',
      TRANSACTIONS_SUMMARY_CREDIT: 'Receitas',
      TRANSACTIONS_SUMMARY_TRANSFER: 'Transferências',
      NO_ACCOUNTS_FOUND_MESSAGE: 'Nenhuma conta encontrada',
      NO_CATEGORIES_FOUND_MESSAGE: 'Nenhuma categoria encontrada',
      ERROR_BOUNDARY_TITLE: 'Oops! Algo correu mal.',
      BACK_TO_HOME: 'Voltar ao Início',
      CRITICAL_ERROR: 'Erro Crítico',
      CONNECTION_ERROR: 'Erro de Ligação',
      OFFLINE_DESC:
        'Sem ligação ao servidor. Por favor, verifique a sua ligação à internet ou tente novamente.',
      SERVER_ERROR_DESC:
        'Estamos com dificuldades no servidor. Por favor, tente novamente mais tarde.',
      RETRY: 'Tentar Novamente',
      NEW_VERSION_AVAILABLE: 'Nova versão disponível',
      RELOAD: 'Recarregar',
      LATER: 'Depois',
      EDIT_TRANSACTION_SUCCESS_TOAST: {
        TITLE: '',
        MESSAGE: 'Movimento atualizado com sucesso',
      },
      EDIT_TRANSACTION_ERROR_TOAST: {
        TITLE: '',
        MESSAGE: 'Ups! Ocorreu um erro ao atualizar o movimento',
      },
      THEME_DARK: 'Modo Escuro',
      THEME_LIGHT: 'Modo Claro',
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    lng: 'pt',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
